import { $http } from "@/assets/js/appFunc";

export const getCatList = (context, payload) => {
    const req = {
        type: "GET",
        url: `/design/catalogs?applicationId=${context.rootGetters["main/getCurrentApplicationId"]}`,
        data: null
    };
    return $http(req, true).then(
        data => context.commit("setCatList", { data, payload })
    );
};

export const deleteCatalog = (context, payload) => {
    const req = {
        type: "DELETE",
        url: `/design/catalogs/${payload}?applicationId=${
            context.rootGetters["main/getCurrentApplicationId"]
        }`,
        noNotify: true
    };
    return $http(req, true);
};

export const getLastCommitId = (context, payload) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const req = {
        type: "GET",
        url: `/design/catalogs/${applicationId}/${payload}/last-commit-id`
    };
    return $http(req, true);
};

export const getTableFormatFromNewCatalog = (context, payload) => {
    const columns = [];
    let catFields = [];
    if (payload.catalog) {
        catFields = payload.catalog.fields;
    } else {
        catFields = payload.lastAddedCatalog.fields;
    }
    if (catFields) {
        catFields.forEach(ele => {
            const colName = ele.name;
            columns.push({
                name: colName,
                label: colName,
                align: "left",
                field: colName,
                sortable: true,
                classes: "my-class",
                style: "width: 500px",
                isExstCat:
                    payload.dataTypes.findIndex(
                        dataType => dataType.value === ele.type[0].value
                    ) === -1,
                type: ele.type[0].value
            });
        });
    }
    return columns;
};

export const getTableDetails = (context, cat) => {
    const catalog = cat.mappedCat || cat;
    const req = {
        type: "GET",
        url: `/design/catalogs/${catalog.id}?applicationId=${
            context.rootGetters["main/getCurrentApplicationId"]
        }`
    };
    return $http(req, true).then(
        data => {
            context.commit("setTableDetails", data);
            context.commit("setMasterId", data.data.masterId);
            context.commit("setCommitId", data.data.commitId);
        }
    );
};

export const getCatDetails = (context, cat) => {
    context
        .dispatch("version/getLatestVersionId", null, { root: true })
        .then(version => {
            const req = {
                type: "POST",
                url: `/data/catalogs/content/load/version/${version}/application/${
                    context.rootGetters["main/getCurrentApplicationId"]
                }`,
                data: {
                    type: cat,
                    filters: { active: true },
                    options: {
                        ascending: false,
                        all_languages: true,
                        sort_by: ""
                    }
                }
            };
            $http(req, true).then(
                () => {},
                error => console.log(error)
            );
        });
};

export const recoverCatalog = (store, payload) => {
    const params = {
        url: "/design/catalogs/recover",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
};

export const saveCatalogAll = (context, payload) => {
    const req = {
        type: "POST",
        url: "/design/catalogs/persist",
        data: payload
    };
    return $http(req, true).then(
        (data) => {
            context.commit("setUnsavedChanges", []);
            return data;
        }
    );
};

export const expCatListExcel = (context, catList) => new Promise((resolve, reject) => {
    context
        .dispatch("version/getLatestVersionId", null, { root: true })
        .then(() => {
            const req = {
                type: "POST",
                url: `/design/catalogs/list/content/export/excel/application/${
                    context.rootGetters["main/getCurrentApplicationId"]
                }`,
                data: catList,
                responseType: "arraybuffer",
                headers: {
                    "Content-type": "application/json",
                    Accept: "application/octet-stream"
                },
                noNotify: true
            };
            return $http(req, true)
                .then(data => {
                    data.fileName = catList;
                    context.commit("expCatListXls", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
});

export const expCatListJson = (context, catList) => {
    const req = {
        type: "POST",
        url: `/design/catalogs/list/content/export/json/application/${
            context.rootGetters["main/getCurrentApplicationId"]
        }`,
        data: catList
    };
    $http(req, true).then(
        data => {
            data.fileName = catList;
            context.commit("expCatListJsn", data);
        },
        error => console.log(error)
    );
};

export const expCatExcel = (context, catalog) => new Promise((resolve, reject) => {
    const req = {
        type: "POST",
        url: "/design/catalogs/content/export/excel",
        data: catalog,
        responseType: "arraybuffer",
        headers: {
            "Content-type": "application/json",
            Accept: "application/octet-stream"
        },
        noNotify: true
    };
    return $http(req, true)
        .then(data => {
            const arr = [];
            arr.push(catalog.name);
            data.fileName = arr;
            context.commit("expCatListXls", data);
            resolve(data);
        })
        .catch(error => {
            reject(error);
        });
});

export const expCatJson = (context, catalog) => {
    const req = {
        type: "POST",
        url: "/design/catalogs/content/export/json",
        data: catalog
    };
    $http(req, true).then(
        data => {
            const arr = [];
            arr.push(catalog.name);
            data.fileName = arr;
            context.commit("expCatListJsn", data);
        },
        error => console.log(error)
    );
};

export const uplCatList = (context, catList) => new Promise((resolve, reject) => {
    context
        .dispatch("version/getLatestVersionId", null, { root: true })
        .then(() => {
            const req = {
                type: "POST",
                url: `/design/catalogs/content/import/application/${
                    context.rootGetters["main/getCurrentApplicationId"]
                }`,
                data: catList,
                headers: { "Content-type": false },
                noNotify: true
            };
            return $http(req, true)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
});

export const uplCatListJson = (context, catList) => new Promise((resolve, reject) => {
    context
        .dispatch("version/getLatestVersionId", null, { root: true })
        .then(() => {
            const req = {
                type: "POST",
                url: `/design/catalogs/content/import/json/application/${
                    context.rootGetters["main/getCurrentApplicationId"]}`,
                data: catList,
                headers: { "Content-type": false },
                noNotify: true
            };
            return $http(req, true)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
});

export const getHistoryCatPreviewData = (store, payload) => {
    const params = {
        url: "/design/catalogs/preview",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
};
